<template>
  <div>
    <page-header name="Cronograma"/>
    <div v-if="url_timeline === ''">
      <h2>Cronograma não configurado</h2>
    </div>
    <div v-else>
      <b-card class="p-0 m-0" style="padding: 0px !important; margin: 0px!important;">
        <iframe :key="url_timeline" :src="url_timeline" :height="windowHeight" width="100%" frameborder="0" allowfullscreen/>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PromotionTimeLine',
  data() {
    return {
      promotion: this.currentPromotion,
      url_timeline: '',
      windowHeight: window.innerHeight - 230,
      _timelineHandler: null,
    }
  },
  async created() {
    await this.fetchLatestTimeline() 
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this._timelineHandler = (ev) => {
      const { uuid, url } = ev.detail || {}
      const current = this.$user.getCurrentPromotion && this.$user.getCurrentPromotion()
      if (!current || current.uuid !== uuid) return
      this.url_timeline = (url || '').trim()
    }
    window.addEventListener('PROMOTION_TIMELINE_UPDATED', this._timelineHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)

    if (this._timelineHandler) {
      window.removeEventListener('PROMOTION_TIMELINE_UPDATED', this._timelineHandler)
      this._timelineHandler = null
    }
  },
  watch: {
    $route() {
      this.fetchLatestTimeline()
    },
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight - 230
    },
    async fetchLatestTimeline() {
      if (this.loading) return
      const promotion = this.$user.getCurrentPromotion && this.$user.getCurrentPromotion()
      if (!promotion) {
        this.$router.push(`/change-promotions?ref=${this.$route.path}`)
        return
      }
      try {
        this.loading = true
        const fresh = await this.$http.get(`promotions/${promotion.uuid}?_=${Date.now()}`)
        const u = fresh?.settings?.timeline_url || ''
        this.url_timeline = typeof u === 'string' ? u.trim() : ''
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

